import { createApp } from "vue";
import App from "./App.vue";
import router from "./route/router";
import VueApexCharts from "vue3-apexcharts";
import VueVirtualScroller from "vue3-virtual-scroller";
import "vue3-virtual-scroller/dist/vue3-virtual-scroller.css";

import pinia from "./pinia";

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(VueApexCharts);
app.use(VueVirtualScroller);

app.component("ApexChart", VueApexCharts);

const resizeObserverLoopErrRe =
  /^ResizeObserver loop (limit exceeded|completed with undelivered notifications)\.?$/;

window.addEventListener("error", (e) => {
  if (resizeObserverLoopErrRe.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  if (
    e.reason &&
    typeof e.reason.message === "string" &&
    resizeObserverLoopErrRe.test(e.reason.message)
  ) {
    e.preventDefault();
  }
});

app.mount("#app");